/* user-register.view.js */
import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { Container } from '@material-ui/core'
import { Stepper, Step } from '@progress/kendo-react-layout'
import { Button } from '@progress/kendo-react-buttons'
import { Form, FormElement } from '@progress/kendo-react-form'
import { HeaderHLPure, SimpleFooterPure } from '../../pures'
import { ETicketLogo } from '../../../assets/logos'
import slogan from '../../../assets/logos/logo_finger_print.png'
import { Grid } from '@material-ui/core'
import './user-register.css'
import { LocalStorageService } from '../../../services'


/**
 * @type {*}
 * @status no delete
 */
const ButtonContainer = {
  marginTop: "15px",
  marginBottom: "15px",
  display: "flex",
  justifyContent: "center",
  paddingBottom: "20px",
};


/**
 * @param {*} props
 * @status no delete
 * @description creates a custom step item, with only the image in tact and no description
 */
const CustomStepItem = (props) => (
  <Step {...props}>
    <span className="k-step-indicator">
      <img src={props.icon} alt="" className="item-step-icon" />
    </span>
  </Step>
);


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 * @description Layout of the user register view pages for the registration process. 
 */
const UserRegisterView = (props) => {
  let StepComponent = props.stepMetadata[props.selectedStep].component;

  const { t, i18n } = useTranslation();
  const [clientLogo, setclientLogo] = useState(null);
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    let localStorageService = new LocalStorageService();
    let logo = localStorageService.getLocalStorageItem("clientLogo");

    if (logo) {
      setclientLogo(logo);
    }
  }, []);

  useEffect(() => {
    let value = true;

    setSubmit(value);
  }, [
    props.attempOfPayment,
    props.a3Direct,
    props.transfer,
    props.messageTransfer,
    props.card,
    props.selectedPersonTypeId,
    props.selectedStep,
    props.personlDataFill,
    props.businessDataFill,
  ]);

  props.changeTranslates(props.steps, t, i18n);

  let initialValues = {
    firstName: props.firstName,
    firstLastName: props.firstLastName,
    secondLastName: props.secondLastName,
    rfc: props.rfc,
    cellphoneNumber: props.cellphoneNumber,
    activityDescription: props.activityDescription,
    economicSector: props.economicSector,
    numUsers: props.numUsers,
    numEmployees: props.numEmployees
  };

  return <div className='user-registration-container'>
    <div className='user-registration-header-layout header-regiter-person' item>
      <div className='logo-register-person'>
        <img alt='Logo de e-ticket' className='data-logo-person-header' height='48' src={ETicketLogo} />
      </div>
      {clientLogo && (
        <img
          alt="Logo del cliente"
          className="data-logo-person-header"
          style={{ height: "80px", padding: "0px", margin: "8px" }}
          src={clientLogo}
        />
      )}
      <div className="data-akubicafirmadigital-person">
        <p
          alt="Logo de govo.legal"
          className="data-akubicaFirmaDigital-person-img"
          height="70"
          align="center"
          src={slogan}
        >
          Slogan <br /> govo.legal
        </p>
      </div>
    </div>
    <Container className='user-registration-content-layout'>
      <Grid container>
        <Grid item xs={12}>
          <HeaderHLPure title="Onboarding" />
        </Grid>

        <Grid item xs={12}>
          <Stepper
            className='custom-stepper'
            value={props.selectedStep}
            items={props.steps}
            item={CustomStepItem}
          >
          </Stepper>
        </Grid>
        <Grid item xs={12}>
          <Form
            initialValues={initialValues}
            allowSubmit={true}
            valid={true}
            modified={true}
            touched={true}
            viseted={true}
            onSubmit={props.onSubmit}
            render={(formRenderProps) => {
              return (
                <Container className="form">
                  <Container className="user-register-form" spacing={4}>
                    <FormElement className="center form-element-size">
                      <div className='title-form'>
                        <div className="title-stepper">
                          <div className="title-form-step">
                            <h3 className="user-register-title">
                              {props.steps[props.selectedStep].itemElement}
                            </h3>
                          </div>
                        </div>
                        <div className='data-step-component'>
                          <StepComponent
                            {...props}
                            validator={props.validator}
                            regex={props.regex}
                            validateInput={props.validateInput}
                            selectedPersonTypeId={props.selectedPersonTypeId}
                          />
                        </div>
                      </div>
                      <div
                        style={ButtonContainer}
                        className="k-form-buttons buttons mb-3 "
                        spacing={4}
                      >
                        {props.contractCreated ? (
                          <Button
                            // primary={true}
                            className="user-register-button-accept-user-app"
                            onClick={(e) =>
                              props.isLastStep
                                ? props.goToApp()
                                : props.onSubmit()
                            }
                          >
                            {props.isLastStep
                              ? "Ir a la aplicación"
                              : "Continuar"}
                          </Button>
                        ) : (
                          <>

                            {(props.stepMetadata[props.selectedStep].name !== "validateOTP" && props.stepMetadata[props.selectedStep].name !== "addressForm") ?
                              (<Button
                                // primary={true}
                                className='user-register-button-accept-user'
                                onClick={(e) => props.onBackStep(e)}>
                                {props.steps[props.selectedStep].labelreturn}
                              </Button>
                              )
                              :
                              ("")
                            }

                            <Button
                              type={'submit'}
                              // primary={true}
                              style={{ marginLeft: '15px' }}
                              className='user-register-button-accept-user-app'
                              onClick={(event) => ((submit && !formRenderProps.allowSubmit && formRenderProps.valid)) ? props.onSubmit(event) : null}
                            >
                              {props.a3Direct ? 'Continuar' : props.steps[props.selectedStep].itemSup}
                            </Button>
                          </>
                        )
                        }
                      </div>
                    </FormElement>
                  </Container>
                </Container>
              );
            }}
          />
        </Grid>
      </Grid>
    </Container>
    <div className="user-registration-footer-layout">
      <SimpleFooterPure />
    </div>
  </div>
};

export { UserRegisterView as default };
